import { Employee } from 'modules/core/hooks/useCurrentSession'

import { InsightsWidgets } from 'modules/expenses/components/expenses/DataTable/_ExpensesInsights'
import { PageDateFilters } from 'modules/expenses/lib/PageDateFiltersContext'

interface ExpensesDataCollectionInsightsProps {
  getFiltersVariables: () => { filter?: Record<string, unknown> } | undefined
  locale: string
  groupId?: number
  employee?: Employee
  dateFilters?: PageDateFilters
}

export const ExpensesDataCollectionInsights = ({
  getFiltersVariables,
  locale,
  groupId,
  employee,
  dateFilters,
}: ExpensesDataCollectionInsightsProps) => {
  return (
    <InsightsWidgets
      getFiltersVariables={getFiltersVariables}
      locale={locale}
      groupId={groupId}
      employee={employee}
      dateFilters={dateFilters}
    />
  )
}
